/* Options:
Date: 2020-03-10 09:10:45
Version: 5.51
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: http://localhost:62113

//GlobalNamespace: 
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
//ExcludeTypes: 
//DefaultImports: 
*/


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IGet
{
}

export interface IPost
{
}

export class PlatypusUserPlotsEventsSummary
{
    public constructor(init?:Partial<PlatypusUserPlotsEventsSummary>) { (<any>Object).assign(this, init); }
    public lastScan: string;
    public totalScans: number;
    public platypusCount: number;
    public totalScansInPrimeTime: number;
    public totalScansCurrentQuarter: number;
}

export enum SummaryPeriod
{
    MONTH = 'MONTH',
    DAY = 'DAY',
    YEAR = 'YEAR',
}

export class QuestionResult
{
    public constructor(init?:Partial<QuestionResult>) { (<any>Object).assign(this, init); }
    public surveyQuestionId: number;
    public questionTypeCode: string;
    public questionCode: string;
    public value: string;
}

export class PlotEventQuestion
{
    public constructor(init?:Partial<PlotEventQuestion>) { (<any>Object).assign(this, init); }
    public plotEventId: number;
    public value: string;
    public description: string;
    public displayValue: string;
    public graphLabel: string
    public marker: boolean;
    public graph: boolean;
    public type: string;
    public rank: number;
    public surveyQuestionId: number;
}

export class PlotEvent
{
    public constructor(init?:Partial<PlotEvent>) { (<any>Object).assign(this, init); }
    public id: number;
    public plotId: number;
    public userId: number;
    public createdDate: string;
    public eventStartDate: string;
    public eventEndDate: string;
    public private: boolean;
    public questionResults: QuestionResult[];
    public plotEventQuestions: PlotEventQuestion[];
}

// @DataContract
export class ResponseError
{
    public constructor(init?:Partial<ResponseError>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1, EmitDefaultValue=false)
    public errorCode: string;

    // @DataMember(Order=2, EmitDefaultValue=false)
    public fieldName: string;

    // @DataMember(Order=3, EmitDefaultValue=false)
    public message: string;

    // @DataMember(Order=4, EmitDefaultValue=false)
    public meta: { [index:string]: string; };
}

// @DataContract
export class ResponseStatus
{
    public constructor(init?:Partial<ResponseStatus>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index:string]: string; };
}

export class PlotStatus
{
    public constructor(init?:Partial<PlotStatus>) { (<any>Object).assign(this, init); }
    public id: number;
    public code: string;
    public label: string;
}

export class FileRecord
{
    public constructor(init?:Partial<FileRecord>) { (<any>Object).assign(this, init); }
    public id: number;
    public fileNameWithExtension: string;
    public fileName: string;
    public extension: string;
    public uploadedName: string;
    public createdDate: string;
    public createdByUserId: number;
}

export class Plot
{
    public constructor(init?:Partial<Plot>) { (<any>Object).assign(this, init); }
    public id: number;
    public name: string;
    public longitude: number;
    public latitude: number;
    public state: string;
    public userId: number;
    public private: boolean;
    public obsolete: boolean;
    public createdDate: string;
    public startDate: string;
    public endDate: string;
    public plotEvents: PlotEvent[];
    public fullName: string;
    public registered: boolean;
    public newestPlotEventDate: string;
    public userNewestPlotEventDate: string;
    public totalPlotEventCount: number;
    public userPlotEventsCount: number;
    public userTotalSightingsCount: number;
    public userOrderMonitored: number;
    public plotStatus: PlotStatus;
    public nearestSuburb: string;
    public waterBody: string;
    public apcCode: string;
    public plotPhoto: FileRecord;
}

export class ClassificationType
{
    public constructor(init?:Partial<ClassificationType>) { (<any>Object).assign(this, init); }
    public id: number;
    public code: string;
    public description: string;
    public obsolete: boolean;
    public rank: number;
}

export class Classification
{
    public constructor(init?:Partial<Classification>) { (<any>Object).assign(this, init); }
    public id: number;
    public code: string;
    public description: string;
    public isPublic: boolean;
    public classificationTypeId: number;
    public classificationType: ClassificationType;
    public rank: number;
}

export class SummaryData
{
    public constructor(init?:Partial<SummaryData>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public classifications: Classification[];
    public period: string;
    public plotEventCount: number;
    public total: number;
}

export class Permission
{
    public constructor(init?:Partial<Permission>) { (<any>Object).assign(this, init); }
    public id: number;
    public plotId: number;
    public name: string;
    public description: string;
}

export class User
{
    public constructor(init?:Partial<User>) { (<any>Object).assign(this, init); }
    public id: number;
    public productId: number;
    public fullName: string;
    public email: string;
    public userName: string;
    public postcode: string;
    public mobileNumber: string;
    public regionId: number;
    public agreedTerms: boolean;
    public isAnonymous: boolean;
    public lastActivityDate: string;
    public lastScanDate: string;
    public emailVerified: boolean;
    public obsolete: boolean;
    public apcCode: string;
    public createdDate: string;
    public userPreferences: { [index:string]: string; };
    public probationary: boolean;
    public emailOptOut: boolean;
    public platypusSeen: string;
    public permissions: Permission[];
    public userRoles: string[];
    public surname: string;
}

export class UserGroup
{
    public constructor(init?:Partial<UserGroup>) { (<any>Object).assign(this, init); }
    public id: number;
    public productId: number;
    public name: string;
    public description: string;
    public private: boolean;
    public obsolete: boolean;
}

export class UserGroupMember
{
    public constructor(init?:Partial<UserGroupMember>) { (<any>Object).assign(this, init); }
    public id: number;
    public userId: number;
    public userGroupId: number;
    public isAdmin: boolean;
    public fullName: string;
    public lastActivityDate: string;
    public email: string;
    public selfNominated: boolean;
}

export class Role
{
    public constructor(init?:Partial<Role>) { (<any>Object).assign(this, init); }
    public id: number;
    public name: string;
    public description: string;
}

export class UserRole
{
    public constructor(init?:Partial<UserRole>) { (<any>Object).assign(this, init); }
    public id: number;
    public userId: number;
    public roleId: number;
    public plotId?: number;
    public user: User;
    public role: Role;
    public plot: Plot;
}

export class QuestionOption
{
    public constructor(init?:Partial<QuestionOption>) { (<any>Object).assign(this, init); }
    public optionId: number;
    public type: string;
    public value: string;
    public label: string;
    public rank: number;
    public questions: SurveyQuestion[];
}

export class SurveyQuestion
{
    public constructor(init?:Partial<SurveyQuestion>) { (<any>Object).assign(this, init); }
    public surveyQuestionId: number;
    public questionId: number;
    public questionCode: string;
    public questionDescription: string;
    public questionTypeCode: string;
    public value: string;
    public filterEnabled: boolean;
    public metadataType: string;
    public mandatory: boolean;
    public rank: number;
    public options: QuestionOption[];
    public questions: SurveyQuestion[];
}

export class Survey
{
    public constructor(init?:Partial<Survey>) { (<any>Object).assign(this, init); }
    public id: number;
    public description: string;
    public createdByUserId: number;
    public obsolete: boolean;
    public defaultPrivate: boolean;
    public displayEndDate: boolean;
    public displayComments: boolean;
    public displayPrivate: boolean;
    public displayAttachments: boolean;
    public surveyCode: string;
    public questions: SurveyQuestion[];
    public classifications: Classification[];
}

export class SummaryUser
{
    public constructor(init?:Partial<SummaryUser>) { (<any>Object).assign(this, init); }
    public id: number;
    public fullName: string;
}

export class SummaryUserGroup
{
    public constructor(init?:Partial<SummaryUserGroup>) { (<any>Object).assign(this, init); }
    public id: number;
    public name: string;
}

export class KeyValue
{
    public constructor(init?:Partial<KeyValue>) { (<any>Object).assign(this, init); }
    public key: string;
    public value: number;
    public label: string;
}

export class PlotSummary
{
    public constructor(init?:Partial<PlotSummary>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public years: number[];
    public lastPlotEvent: string;
    public participantCount: number;
    public plotEventCount: number;
    public primaryValue: KeyValue;
}

export class PlatypusPlotSeasonSummary
{
    public constructor(init?:Partial<PlatypusPlotSeasonSummary>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public season: Classification;
    public timeOfDay: Classification;
    public year: number;
    public plotEventCount: number;
    public platypusCount: number;
}

export class IntegerData
{
    public constructor(init?:Partial<IntegerData>) { (<any>Object).assign(this, init); }
    public label: string;
    public value1: number;
    public value2: number;
    public children: IntegerData[];
}

export class GroupedDataPoint
{
    public constructor(init?:Partial<GroupedDataPoint>) { (<any>Object).assign(this, init); }
    public key: number;
    public label: string;
    public keyValues: KeyValue[];
}

export class GroupedData
{
    public constructor(init?:Partial<GroupedData>) { (<any>Object).assign(this, init); }
    public keyList: KeyValue[];
    public data: GroupedDataPoint[];
    public label: string;
}

export class GraphNamedData
{
    public constructor(init?:Partial<GraphNamedData>) { (<any>Object).assign(this, init); }
    public name: string;
    public data: string[][];
}

export class Template
{
    public constructor(init?:Partial<Template>) { (<any>Object).assign(this, init); }
    public id: number;
    public layoutId: number;
    public configurationId: number;
    public name: string;
    public description: string;
    public body: string;
    public layoutName: string;
}

export class KMLLayer
{
    public constructor(init?:Partial<KMLLayer>) { (<any>Object).assign(this, init); }
    public id: number;
    public name: string;
    public kmlFileName: string;
    public layerColour: string;
    public enabled: boolean;
}

export class UserPreference
{
    public constructor(init?:Partial<UserPreference>) { (<any>Object).assign(this, init); }
    public id: number;
    public userId: number;
    public blob: string;
}

export class OptionDateExtended extends QuestionOption
{
    public constructor(init?:Partial<OptionDateExtended>) { super(init); (<any>Object).assign(this, init); }
    public dateStartDifference: number;
}

export class WebsiteSettings
{
    public constructor(init?:Partial<WebsiteSettings>) { (<any>Object).assign(this, init); }
    public adminContactEmail: string;
    public testEnvironment: boolean;
}

export class GetPlatypusUserPlotsEventsSummaryResponse
{
    public constructor(init?:Partial<GetPlatypusUserPlotsEventsSummaryResponse>) { (<any>Object).assign(this, init); }
    public userPlotEventsSummaryData: PlatypusUserPlotsEventsSummary;
}

export class GetPlotEventsResponse
{
    public constructor(init?:Partial<GetPlotEventsResponse>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public plotEvents: PlotEvent[];
    public responseStatus: ResponseStatus;
}

export class GetPlotsResponse
{
    public constructor(init?:Partial<GetPlotsResponse>) { (<any>Object).assign(this, init); }
    public plots: Plot[];
}

export class GetSinglePlotResponse
{
    public constructor(init?:Partial<GetSinglePlotResponse>) { (<any>Object).assign(this, init); }
    public plot: Plot;
}

export class GetSummaryDataByClassificationResponse
{
    public constructor(init?:Partial<GetSummaryDataByClassificationResponse>) { (<any>Object).assign(this, init); }
    public data: SummaryData[];
    public responseStatus: ResponseStatus;
}

export class GetUserPlotsResponse
{
    public constructor(init?:Partial<GetUserPlotsResponse>) { (<any>Object).assign(this, init); }
    public plots: Plot[];
    public responseStatus: ResponseStatus;
}

export class FlagPlotResponse
{
    public constructor(init?:Partial<FlagPlotResponse>) { (<any>Object).assign(this, init); }
    public success: boolean;
    public plots: Plot[];
}

export class DeleteFileResponse
{
    public constructor(init?:Partial<DeleteFileResponse>) { (<any>Object).assign(this, init); }
    public responseStatus: ResponseStatus;
}

export class UploadResponse
{
    public constructor(init?:Partial<UploadResponse>) { (<any>Object).assign(this, init); }
    public uploadedFile: FileRecord;
    public responseStatus: ResponseStatus;
}

export class AdminSaveUserResponse
{
    public constructor(init?:Partial<AdminSaveUserResponse>) { (<any>Object).assign(this, init); }
    public responseStatus: ResponseStatus;
    public user: User;
}

export class AdminSaveUserGroupResponse
{
    public constructor(init?:Partial<AdminSaveUserGroupResponse>) { (<any>Object).assign(this, init); }
    public group: UserGroup;
}

export class AdminUpdateAdminUserGroupResponse
{
    public constructor(init?:Partial<AdminUpdateAdminUserGroupResponse>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public user: UserGroupMember;
}

export class AdminAddUserToGroupResponse
{
    public constructor(init?:Partial<AdminAddUserToGroupResponse>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public user: UserGroupMember;
}

export class AdminApproveUserForGroupResponse
{
    public constructor(init?:Partial<AdminApproveUserForGroupResponse>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public user: UserGroupMember;
}

export class AdminDeleteUserFromGroupResponse
{
    public constructor(init?:Partial<AdminDeleteUserFromGroupResponse>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public userId: number;
}

export class CsvFileResult
{
    public constructor(init?:Partial<CsvFileResult>) { (<any>Object).assign(this, init); }
    public options: { [index:string]: string; };
}

export class AdminBatchImportResponse
{
    public constructor(init?:Partial<AdminBatchImportResponse>) { (<any>Object).assign(this, init); }
    public responseStatus: ResponseStatus;
    public importedCount: number;
}

export class AdminUserRolesResponse
{
    public constructor(init?:Partial<AdminUserRolesResponse>) { (<any>Object).assign(this, init); }
    public response: ResponseStatus;
    public userRoles: UserRole[];
}

export class AdminUsersResponse
{
    public constructor(init?:Partial<AdminUsersResponse>) { (<any>Object).assign(this, init); }
    public users: User[];
}

export class AdminPlotsResponse
{
    public constructor(init?:Partial<AdminPlotsResponse>) { (<any>Object).assign(this, init); }
    public plots: Plot[];
}

export class AdminGetPlotMetaInfoResponse
{
    public constructor(init?:Partial<AdminGetPlotMetaInfoResponse>) { (<any>Object).assign(this, init); }
    public apcCodes: string[];
    public waterBodys: string[];
    public users: User[];
    public userRoles: UserRole[];
}

export class AdminFilesResponse
{
    public constructor(init?:Partial<AdminFilesResponse>) { (<any>Object).assign(this, init); }
    public files: FileRecord[];
}

export class AdminUserGroupsResponse
{
    public constructor(init?:Partial<AdminUserGroupsResponse>) { (<any>Object).assign(this, init); }
    public groups: UserGroup[];
}

export class SurveyResponse
{
    public constructor(init?:Partial<SurveyResponse>) { (<any>Object).assign(this, init); }
    public survey: Survey;
    public responseStatus: ResponseStatus;
}

export class SaveSurveyResponse
{
    public constructor(init?:Partial<SaveSurveyResponse>) { (<any>Object).assign(this, init); }
    public plotEvent: PlotEvent;
    public responseStatus: ResponseStatus;
}

export class GetSummaryMetadataResponse
{
    public constructor(init?:Partial<GetSummaryMetadataResponse>) { (<any>Object).assign(this, init); }
    public user: SummaryUser;
    public userGroup: SummaryUserGroup;
}

export class GetPlotSummaryDataResponse
{
    public constructor(init?:Partial<GetPlotSummaryDataResponse>) { (<any>Object).assign(this, init); }
    public plotSummaryData: PlotSummary[];
    public responseStatus: ResponseStatus;
}

export class GetPlotSeasonSummaryDataResponse
{
    public constructor(init?:Partial<GetPlotSeasonSummaryDataResponse>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public plotSeasonSummaryData: PlatypusPlotSeasonSummary[];
    public responseStatus: ResponseStatus;
    public platDummy: PlatypusPlotSeasonSummary;
}

export class GetSummarySurveyResultsResponse
{
    public constructor(init?:Partial<GetSummarySurveyResultsResponse>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public surveyId: number;
    public summaryResults: IntegerData[];
    public groupedUserResults: GroupedData;
}

export class GetSummaryPlotEventsCountResponse
{
    public constructor(init?:Partial<GetSummaryPlotEventsCountResponse>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public graphData: GraphNamedData[];
}

export class GetUserGroupResponse
{
    public constructor(init?:Partial<GetUserGroupResponse>) { (<any>Object).assign(this, init); }
    public userGroup: UserGroup;
}

export class GetTemplateResponse
{
    public constructor(init?:Partial<GetTemplateResponse>) { (<any>Object).assign(this, init); }
    public templates: Template[];
}

export class GetUserResponse
{
    public constructor(init?:Partial<GetUserResponse>) { (<any>Object).assign(this, init); }
    public user: User;
}

export class GetAuthenticatedUserResponse
{
    public constructor(init?:Partial<GetAuthenticatedUserResponse>) { (<any>Object).assign(this, init); }
    public responseStatus: ResponseStatus;
    public user: User;
}

export class UpdateUserResponse
{
    public constructor(init?:Partial<UpdateUserResponse>) { (<any>Object).assign(this, init); }
    public responseStatus: ResponseStatus;
    public user: User;
}

export class RegisterUserResponse
{
    public constructor(init?:Partial<RegisterUserResponse>) { (<any>Object).assign(this, init); }
    public responseStatus: ResponseStatus;
}

export class ResetPasswordResponse
{
    public constructor(init?:Partial<ResetPasswordResponse>) { (<any>Object).assign(this, init); }
    public result: boolean;
    public user: User;
    public responseStatus: ResponseStatus;
}

export class IsValidChangePasswordTokenResponse
{
    public constructor(init?:Partial<IsValidChangePasswordTokenResponse>) { (<any>Object).assign(this, init); }
    public validToken: boolean;
}

export class RequestAccountActivationResponse
{
    public constructor(init?:Partial<RequestAccountActivationResponse>) { (<any>Object).assign(this, init); }
    public responseStatus: ResponseStatus;
}

export class ActivateUserAccountResponse
{
    public constructor(init?:Partial<ActivateUserAccountResponse>) { (<any>Object).assign(this, init); }
    public accountActivated: boolean;
}

export class UpdateUserPreferencesResponse
{
    public constructor(init?:Partial<UpdateUserPreferencesResponse>) { (<any>Object).assign(this, init); }
}

export class AssignUserRoleResponse
{
    public constructor(init?:Partial<AssignUserRoleResponse>) { (<any>Object).assign(this, init); }
    public newUserRole: UserRole;
}

export class UnassignUserRoleResponse
{
    public constructor(init?:Partial<UnassignUserRoleResponse>) { (<any>Object).assign(this, init); }
}

export class SearchResponse
{
    public constructor(init?:Partial<SearchResponse>) { (<any>Object).assign(this, init); }
    public plots: Plot[];
    public layers: KMLLayer[];
}

export class SavePlotResponse
{
    public constructor(init?:Partial<SavePlotResponse>) { (<any>Object).assign(this, init); }
    public plot: Plot;
}

export class UploadPlotPhotosResponse
{
    public constructor(init?:Partial<UploadPlotPhotosResponse>) { (<any>Object).assign(this, init); }
    public responseStatus: ResponseStatus;
}

export class DeletePlotEventResponse
{
    public constructor(init?:Partial<DeletePlotEventResponse>) { (<any>Object).assign(this, init); }
    public plotEventId: number;
    public success: boolean;
}

export class SaveResponse
{
    public constructor(init?:Partial<SaveResponse>) { (<any>Object).assign(this, init); }
    public success: boolean;
}

export class GetReferenceDataResponse
{
    public constructor(init?:Partial<GetReferenceDataResponse>) { (<any>Object).assign(this, init); }
    public userHasAuthenticatedSession: boolean;
    public classifications: Classification[];
    public dateRange: OptionDateExtended[];
    public types: QuestionOption[];
    public userPreference: UserPreference;
    public surveys: Survey[];
    public websiteSettings: WebsiteSettings;
    public plotStatuses: PlotStatus[];
}

export class GetQuestionReferenceDataResponse
{
    public constructor(init?:Partial<GetQuestionReferenceDataResponse>) { (<any>Object).assign(this, init); }
    public result: QuestionOption[];
}

export class ReportResponse
{
    public constructor(init?:Partial<ReportResponse>) { (<any>Object).assign(this, init); }
    public result: string;
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    public constructor(init?:Partial<AuthenticateResponse>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=9)
    public meta: { [index:string]: string; };
}

// @DataContract
export class AssignRolesResponse
{
    public constructor(init?:Partial<AssignRolesResponse>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;
}

// @DataContract
export class UnAssignRolesResponse
{
    public constructor(init?:Partial<UnAssignRolesResponse>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;
}

// @DataContract
export class ConvertSessionToTokenResponse
{
    public constructor(init?:Partial<ConvertSessionToTokenResponse>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public meta: { [index:string]: string; };

    // @DataMember(Order=2)
    public accessToken: string;

    // @DataMember(Order=3)
    public refreshToken: string;

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;
}

// @DataContract
export class GetAccessTokenResponse
{
    public constructor(init?:Partial<GetAccessTokenResponse>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public accessToken: string;

    // @DataMember(Order=2)
    public responseStatus: ResponseStatus;
}

// @Route("/api/report/sample")
export class GetSampleReport
{
    public constructor(init?:Partial<GetSampleReport>) { (<any>Object).assign(this, init); }
}

// @Route("/api/report/group/{GroupId}")
export class GetGroupReport
{
    public constructor(init?:Partial<GetGroupReport>) { (<any>Object).assign(this, init); }
    public product: string;
    public groupId: number;
    public surveyCodes: string[];
    public plotEventStartDate: string;
    public plotEventEndDate: string;
}

export class GetPlatypusUserPlotEventsSummaryData implements IReturn<GetPlatypusUserPlotsEventsSummaryResponse>
{
    public constructor(init?:Partial<GetPlatypusUserPlotEventsSummaryData>) { (<any>Object).assign(this, init); }
    public product: string;
    public createResponse() { return new GetPlatypusUserPlotsEventsSummaryResponse(); }
    public getTypeName() { return 'GetPlatypusUserPlotEventsSummaryData'; }
}

// @Route("/api/data/plotEvents/user/count", "GET")
export class GetPlotEventsUserCount
{
    public constructor(init?:Partial<GetPlotEventsUserCount>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public surveyId: number;
    public summaryPeriod: SummaryPeriod;
    public plotEventStartDateStart: string;
    public plotEventStartDateEnd: string;
}

// @Route("/api/plot/events")
// @Route("/api/plot/{PlotId}/events")
export class GetPlotEvents implements IReturn<GetPlotEventsResponse>
{
    public constructor(init?:Partial<GetPlotEvents>) { (<any>Object).assign(this, init); }
    public userId: number;
    public plotId: number;
    public limit: number;
    public eventDateStart: string;
    public eventDateEnd: string;
    public createResponse() { return new GetPlotEventsResponse(); }
    public getTypeName() { return 'GetPlotEvents'; }
}

// @Route("/api/data/plots", "GET")
export class GetPlots implements IReturn<GetPlotsResponse>
{
    public constructor(init?:Partial<GetPlots>) { (<any>Object).assign(this, init); }
    public product: string;
    public classification: string;
    public createdDateStart: string;
    public createdDateEnd: string;
    public plotEventStartedDateStart: string;
    public plotEventStartedDateEnd: string;
    public plotStatusCodesToInclude: string[];
    public createResponse() { return new GetPlotsResponse(); }
    public getTypeName() { return 'GetPlots'; }
}

// @Route("/api/plot/{PlotId}")
export class GetSinglePlot implements IReturn<GetSinglePlotResponse>
{
    public constructor(init?:Partial<GetSinglePlot>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public createResponse() { return new GetSinglePlotResponse(); }
    public getTypeName() { return 'GetSinglePlot'; }
}

export class GetSummaryDataByClassification implements IReturn<GetSummaryDataByClassificationResponse>
{
    public constructor(init?:Partial<GetSummaryDataByClassification>) { (<any>Object).assign(this, init); }
    public product: string;
    public plotId: number;
    public classificationTypes: string[];
    public summaryPeriod: SummaryPeriod;
    public questionCode: string;
    public createResponse() { return new GetSummaryDataByClassificationResponse(); }
    public getTypeName() { return 'GetSummaryDataByClassification'; }
}

// @Route("/api/user/plots")
// @Route("/api/user/{UserId}/plots")
// @Route("/api/userPlots")
export class GetUserPlots implements IReturn<GetUserPlotsResponse>
{
    public constructor(init?:Partial<GetUserPlots>) { (<any>Object).assign(this, init); }
    public userId: number;
    public product: string;
    public includePlotEvents: boolean;
    public createResponse() { return new GetUserPlotsResponse(); }
    public getTypeName() { return 'GetUserPlots'; }
}

// @Route("/api/plot/{id}/flag")
export class FlagPlot implements IReturn<FlagPlotResponse>
{
    public constructor(init?:Partial<FlagPlot>) { (<any>Object).assign(this, init); }
    public plot: Plot;
    public createResponse() { return new FlagPlotResponse(); }
    public getTypeName() { return 'FlagPlot'; }
}

// @Route("/api/file/{FileId}", "DELETE")
export class DeleteFile implements IReturn<DeleteFileResponse>
{
    public constructor(init?:Partial<DeleteFile>) { (<any>Object).assign(this, init); }
    public fileId: number;
    public createResponse() { return new DeleteFileResponse(); }
    public getTypeName() { return 'DeleteFile'; }
}

// @Route("/api/plot/{PlotId}/photo", "GET")
export class DownloadFile
{
    public constructor(init?:Partial<DownloadFile>) { (<any>Object).assign(this, init); }
    public plotId: number;
}

// @Route("/api/file", "POST")
export class Upload implements IReturn<UploadResponse>
{
    public constructor(init?:Partial<Upload>) { (<any>Object).assign(this, init); }
    public createResponse() { return new UploadResponse(); }
    public getTypeName() { return 'Upload'; }
}

// @Route("/api/admin/user/{UserId}", "PUT")
export class AdminSaveUser implements IReturn<AdminSaveUserResponse>
{
    public constructor(init?:Partial<AdminSaveUser>) { (<any>Object).assign(this, init); }
    public userId: number;
    public user: User;
    public createResponse() { return new AdminSaveUserResponse(); }
    public getTypeName() { return 'AdminSaveUser'; }
}

// @Route("/api/admin/usersGroups")
export class AdminSaveUserGroup implements IReturn<AdminSaveUserGroupResponse>
{
    public constructor(init?:Partial<AdminSaveUserGroup>) { (<any>Object).assign(this, init); }
    public group: UserGroup;
    public product: string;
    public createResponse() { return new AdminSaveUserGroupResponse(); }
    public getTypeName() { return 'AdminSaveUserGroup'; }
}

// @Route("/api/admin/usersGroups/updateAdmin")
export class AdminUpdateAdminUserGroup implements IReturn<AdminUpdateAdminUserGroupResponse>
{
    public constructor(init?:Partial<AdminUpdateAdminUserGroup>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public userId: number;
    public product: string;
    public createResponse() { return new AdminUpdateAdminUserGroupResponse(); }
    public getTypeName() { return 'AdminUpdateAdminUserGroup'; }
}

// @Route("/api/admin/usersGroups/addUser")
export class AdminAddUserToGroup implements IReturn<AdminAddUserToGroupResponse>
{
    public constructor(init?:Partial<AdminAddUserToGroup>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public email: string;
    public name: string;
    public product: string;
    public createResponse() { return new AdminAddUserToGroupResponse(); }
    public getTypeName() { return 'AdminAddUserToGroup'; }
}

// @Route("/api/admin/usersGroups/approveUser")
export class AdminApproveUserForGroup implements IReturn<AdminApproveUserForGroupResponse>
{
    public constructor(init?:Partial<AdminApproveUserForGroup>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public userId: number;
    public product: string;
    public createResponse() { return new AdminApproveUserForGroupResponse(); }
    public getTypeName() { return 'AdminApproveUserForGroup'; }
}

// @Route("/api/admin/usersGroups/delUser")
export class AdminDeleteUserFromGroup implements IReturn<AdminDeleteUserFromGroupResponse>
{
    public constructor(init?:Partial<AdminDeleteUserFromGroup>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public userId: number;
    public product: string;
    public createResponse() { return new AdminDeleteUserFromGroupResponse(); }
    public getTypeName() { return 'AdminDeleteUserFromGroup'; }
}

// @Route("/api/admin/user/export", "GET")
export class AdminUserExport implements IReturn<CsvFileResult>
{
    public constructor(init?:Partial<AdminUserExport>) { (<any>Object).assign(this, init); }
    public createResponse() { return new CsvFileResult(); }
    public getTypeName() { return 'AdminUserExport'; }
}

// @Route("/api/admin/plot/{PlotId}/export", "GET")
// @Route("/api/admin/plot/apccode/{ApcCode}/export", "GET")
// @Route("/api/admin/plot/waterbody/{WaterBody}/export", "GET")
// @Route("/api/admin/plot/export", "GET")
export class AdminPlotExport implements IReturn<CsvFileResult>
{
    public constructor(init?:Partial<AdminPlotExport>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public apcCode: string;
    public waterBody: string;
    public userId: number;
    public surname: string;
    public startDate: string;
    public endDate: string;
    public createResponse() { return new CsvFileResult(); }
    public getTypeName() { return 'AdminPlotExport'; }
}

// @Route("/api/admin/plot/batch/eventstartdate/recalculate", "GET")
export class AdminBatchEventStartDate implements IReturn<AdminBatchImportResponse>
{
    public constructor(init?:Partial<AdminBatchEventStartDate>) { (<any>Object).assign(this, init); }
    public plotEventIds: number[];
    public createResponse() { return new AdminBatchImportResponse(); }
    public getTypeName() { return 'AdminBatchEventStartDate'; }
}

// @Route("/api/admin/plot/batch/classifications/initial", "GET")
export class AdminBatchInitialClassifications implements IReturn<AdminBatchImportResponse>
{
    public constructor(init?:Partial<AdminBatchInitialClassifications>) { (<any>Object).assign(this, init); }
    public createResponse() { return new AdminBatchImportResponse(); }
    public getTypeName() { return 'AdminBatchInitialClassifications'; }
}

// @Route("/api/admin/plot/{PlotId}/events/batch", "POST")
// @Route("/api/admin/plot/{PlotId}/events/user/{UserId}/batch", "POST")
export class AdminBatchImportPlotEvents implements IReturn<AdminBatchImportResponse>
{
    public constructor(init?:Partial<AdminBatchImportPlotEvents>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public userId: number;
    public createResponse() { return new AdminBatchImportResponse(); }
    public getTypeName() { return 'AdminBatchImportPlotEvents'; }
}

// @Route("/api/admin/plot/batch", "POST")
export class AdminBatchImportPlots implements IReturn<AdminBatchImportResponse>
{
    public constructor(init?:Partial<AdminBatchImportPlots>) { (<any>Object).assign(this, init); }
    public createResponse() { return new AdminBatchImportResponse(); }
    public getTypeName() { return 'AdminBatchImportPlots'; }
}

// @Route("/api/admin/user/roles", "GET")
// @Route("/api/admin/user/roles/plot/{PlotId}", "GET")
// @Route("/api/admin/user/{UserId}/roles/", "GET")
export class AdminSearchUserRoles implements IReturn<AdminUserRolesResponse>
{
    public constructor(init?:Partial<AdminSearchUserRoles>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public userId: number;
    public createResponse() { return new AdminUserRolesResponse(); }
    public getTypeName() { return 'AdminSearchUserRoles'; }
}

// @Route("/api/admin/user", "GET")
// @Route("/api/admin/user/{UserId}", "GET")
export class AdminGetUsers implements IReturn<AdminUsersResponse>
{
    public constructor(init?:Partial<AdminGetUsers>) { (<any>Object).assign(this, init); }
    public userId: number;
    public includeObsolete: boolean;
    public searchText: string;
    public createResponse() { return new AdminUsersResponse(); }
    public getTypeName() { return 'AdminGetUsers'; }
}

// @Route("/api/admin/plot", "GET")
// @Route("/api/admin/plot/{PlotId}", "GET")
export class AdminSearchPlots implements IReturn<AdminPlotsResponse>
{
    public constructor(init?:Partial<AdminSearchPlots>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public includeObsolete: boolean;
    public searchText: string;
    public createResponse() { return new AdminPlotsResponse(); }
    public getTypeName() { return 'AdminSearchPlots'; }
}

// @Route("/api/admin/plot/meta", "GET")
export class AdminGetPlotMetaInfo implements IReturn<AdminGetPlotMetaInfoResponse>
{
    public constructor(init?:Partial<AdminGetPlotMetaInfo>) { (<any>Object).assign(this, init); }
    public createResponse() { return new AdminGetPlotMetaInfoResponse(); }
    public getTypeName() { return 'AdminGetPlotMetaInfo'; }
}

// @Route("/api/admin/files", "GET")
// @Route("/api/admin/files/{FileId}", "GET")
export class AdminSearchFiles implements IReturn<AdminFilesResponse>
{
    public constructor(init?:Partial<AdminSearchFiles>) { (<any>Object).assign(this, init); }
    public fileId: number;
    public searchText: string;
    public createResponse() { return new AdminFilesResponse(); }
    public getTypeName() { return 'AdminSearchFiles'; }
}

// @Route("/api/admin/userGroups")
export class AdminGetUserGroups implements IReturn<AdminUserGroupsResponse>
{
    public constructor(init?:Partial<AdminGetUserGroups>) { (<any>Object).assign(this, init); }
    public searchText: string;
    public product: string;
    public createResponse() { return new AdminUserGroupsResponse(); }
    public getTypeName() { return 'AdminGetUserGroups'; }
}

// @Route("/api/survey", "GET")
export class GetSurvey implements IReturn<SurveyResponse>
{
    public constructor(init?:Partial<GetSurvey>) { (<any>Object).assign(this, init); }
    public product: string;
    public speciesId: number;
    public eventTypeId: number;
    public createResponse() { return new SurveyResponse(); }
    public getTypeName() { return 'GetSurvey'; }
}

// @Route("/api/survey/submit/mobile/platypus", "POST")
export class SaveMobilePlatypusSurvey implements IReturn<boolean>
{
    public constructor(init?:Partial<SaveMobilePlatypusSurvey>) { (<any>Object).assign(this, init); }
    public scanDateTime: string;
    public platypusSeen: number;
    public siteNumber: number;
    public scanGuid: string;
    public scanDevice: string;
    public createResponse() { return false; }
    public getTypeName() { return 'SaveMobilePlatypusSurvey'; }
}

// @Route("/api/survey/submit", "POST")
export class SaveSurvey implements IReturn<SaveSurveyResponse>
{
    public constructor(init?:Partial<SaveSurvey>) { (<any>Object).assign(this, init); }
    public product: string;
    public survey: Survey;
    public createResponse() { return new SaveSurveyResponse(); }
    public getTypeName() { return 'SaveSurvey'; }
}

// @Route("/api/summary/group/{GroupId}", "GET")
// @Route("/api/summary/group/{UserId}", "GET")
export class GetSummaryMetadata implements IReturn<GetSummaryMetadataResponse>
{
    public constructor(init?:Partial<GetSummaryMetadata>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public userId: number;
    public createResponse() { return new GetSummaryMetadataResponse(); }
    public getTypeName() { return 'GetSummaryMetadata'; }
}

// @Route("/api/summary/plot", "GET")
export class GetPlotSummaryData implements IReturn<GetPlotSummaryDataResponse>
{
    public constructor(init?:Partial<GetPlotSummaryData>) { (<any>Object).assign(this, init); }
    public plotIds: number[];
    public classificationIds: number[];
    public plotEventCreatedDateStart: string;
    public plotEventCreatedDateEnd: string;
    public createResponse() { return new GetPlotSummaryDataResponse(); }
    public getTypeName() { return 'GetPlotSummaryData'; }
}

// @Route("/api/summary/plot/{PlotId}/season", "GET")
export class GetPlotSeasonSummaryData implements IReturn<GetPlotSeasonSummaryDataResponse>
{
    public constructor(init?:Partial<GetPlotSeasonSummaryData>) { (<any>Object).assign(this, init); }
    public product: string;
    public plotId: number;
    public createResponse() { return new GetPlotSeasonSummaryDataResponse(); }
    public getTypeName() { return 'GetPlotSeasonSummaryData'; }
}

// @Route("/api/summary/group/{GroupId}/survey/{SurveyCode}", "GET")
// @Route("/api/summary/user/{UserId}/survey/{SurveyCode}", "GET")
export class GetSummarySurveyResults implements IReturn<GetSummarySurveyResultsResponse>
{
    public constructor(init?:Partial<GetSummarySurveyResults>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public userId: number;
    public surveyCode: string;
    public plotEventCreatedStartDate: string;
    public plotEventCreatedEndDate: string;
    public createResponse() { return new GetSummarySurveyResultsResponse(); }
    public getTypeName() { return 'GetSummarySurveyResults'; }
}

// @Route("/api/summary/group/{GroupId}/plotEvents/count", "GET")
// @Route("/api/summary/user/{UserId}/plotEvents/count", "GET")
export class GetSummaryPlotEventsCount implements IReturn<GetSummaryPlotEventsCountResponse>
{
    public constructor(init?:Partial<GetSummaryPlotEventsCount>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public userId: number;
    public summaryPeriod: SummaryPeriod;
    public plotEventStartDateStart: string;
    public plotEventStartDateEnd: string;
    public classificationIds: number[];
    public mustIncludeClassificationId: number;
    public createResponse() { return new GetSummaryPlotEventsCountResponse(); }
    public getTypeName() { return 'GetSummaryPlotEventsCount'; }
}

// @Route("/api/group/{GroupId}", "GET")
export class GetUserGroup implements IReturn<GetUserGroupResponse>
{
    public constructor(init?:Partial<GetUserGroup>) { (<any>Object).assign(this, init); }
    public groupId: number;
    public createResponse() { return new GetUserGroupResponse(); }
    public getTypeName() { return 'GetUserGroup'; }
}

// @Route("/api/template/{TemplateId}/render", "GET")
export class RenderTemplate
{
    public constructor(init?:Partial<RenderTemplate>) { (<any>Object).assign(this, init); }
    public impersonateUserId: number;
    public templateId: number;
    public argPlotId: number;
}

// @Route("/api/template/{TemplateId}/send", "GET")
export class SendTemplate implements IReturnVoid
{
    public constructor(init?:Partial<SendTemplate>) { (<any>Object).assign(this, init); }
    public impersonateUserId: number;
    public templateId: number;
    public createResponse() {}
    public getTypeName() { return 'SendTemplate'; }
}

// @Route("/api/template/{TemplateId}", "GET")
// @Route("/api/template", "GET")
export class GetTemplate implements IReturn<GetTemplateResponse>
{
    public constructor(init?:Partial<GetTemplate>) { (<any>Object).assign(this, init); }
    public templateId: number;
    public searchText: string;
    public createResponse() { return new GetTemplateResponse(); }
    public getTypeName() { return 'GetTemplate'; }
}

// @Route("/api/user/{UserId}", "GET")
export class GetUser implements IReturn<GetUserResponse>
{
    public constructor(init?:Partial<GetUser>) { (<any>Object).assign(this, init); }
    public userId: number;
    public createResponse() { return new GetUserResponse(); }
    public getTypeName() { return 'GetUser'; }
}

// @Route("/api/user/authenticated", "GET")
export class GetAuthenticatedUser implements IReturn<GetAuthenticatedUserResponse>, IGet
{
    public constructor(init?:Partial<GetAuthenticatedUser>) { (<any>Object).assign(this, init); }
    public createResponse() { return new GetAuthenticatedUserResponse(); }
    public getTypeName() { return 'GetAuthenticatedUser'; }
}

// @Route("/api/user/{UserId}", "POST")
export class UpdateUser implements IReturn<UpdateUserResponse>
{
    public constructor(init?:Partial<UpdateUser>) { (<any>Object).assign(this, init); }
    public email: string;
    public fullName: string;
    public surname: string;
    public mobile: string;
    public postCode: string;
    public createResponse() { return new UpdateUserResponse(); }
    public getTypeName() { return 'UpdateUser'; }
}

// @Route("/api/user", "POST")
export class RegisterUser implements IReturn<RegisterUserResponse>
{
    public constructor(init?:Partial<RegisterUser>) { (<any>Object).assign(this, init); }
    public product: string;
    public email: string;
    public fullName: string;
    public surname: string;
    public mobile: string;
    public postCode: string;
    public password: string;
    public agreedTerms: boolean;
    public platypusSeen: string;
    public createResponse() { return new RegisterUserResponse(); }
    public getTypeName() { return 'RegisterUser'; }
}

// @Route("/api/users/resetpassword", "POST")
export class ResetUserPassword implements IReturn<ResetPasswordResponse>
{
    public constructor(init?:Partial<ResetUserPassword>) { (<any>Object).assign(this, init); }
    public userName: string;
    public createResponse() { return new ResetPasswordResponse(); }
    public getTypeName() { return 'ResetUserPassword'; }
}

// @Route("/api/users/changepasswordtoken", "GET")
export class IsValidChangePasswordToken implements IReturn<IsValidChangePasswordTokenResponse>
{
    public constructor(init?:Partial<IsValidChangePasswordToken>) { (<any>Object).assign(this, init); }
    public token: string;
    public createResponse() { return new IsValidChangePasswordTokenResponse(); }
    public getTypeName() { return 'IsValidChangePasswordToken'; }
}

// @Route("/api/user/password", "PUT")
export class ChangeUserPassword implements IReturn<UpdateUserResponse>
{
    public constructor(init?:Partial<ChangeUserPassword>) { (<any>Object).assign(this, init); }
    public newPassword: string;
    public createResponse() { return new UpdateUserResponse(); }
    public getTypeName() { return 'ChangeUserPassword'; }
}

// @Route("/api/user/optout", "PUT")
export class ChangeUserOptOutStatus implements IReturn<UpdateUserResponse>
{
    public constructor(init?:Partial<ChangeUserOptOutStatus>) { (<any>Object).assign(this, init); }
    public optOutStatus: boolean;
    public createResponse() { return new UpdateUserResponse(); }
    public getTypeName() { return 'ChangeUserOptOutStatus'; }
}

// @Route("/api/users/changepasswordtoken", "POST")
export class ChangePasswordFromToken implements IReturn<ResetPasswordResponse>
{
    public constructor(init?:Partial<ChangePasswordFromToken>) { (<any>Object).assign(this, init); }
    public token: string;
    public newPassword: string;
    public createResponse() { return new ResetPasswordResponse(); }
    public getTypeName() { return 'ChangePasswordFromToken'; }
}

// @Route("/api/users/activateaccount", "GET")
export class RequestAccountActivation implements IReturn<RequestAccountActivationResponse>
{
    public constructor(init?:Partial<RequestAccountActivation>) { (<any>Object).assign(this, init); }
    public userName: string;
    public createResponse() { return new RequestAccountActivationResponse(); }
    public getTypeName() { return 'RequestAccountActivation'; }
}

// @Route("/api/users/activateaccount/{token}", "GET")
export class ActiveUserAccount implements IReturn<ActivateUserAccountResponse>
{
    public constructor(init?:Partial<ActiveUserAccount>) { (<any>Object).assign(this, init); }
    public token: string;
    public createResponse() { return new ActivateUserAccountResponse(); }
    public getTypeName() { return 'ActiveUserAccount'; }
}

// @Route("/api/user/{UserId}/invalidatejwttoken", "POST")
export class InvalidateJwtToken
{
    public constructor(init?:Partial<InvalidateJwtToken>) { (<any>Object).assign(this, init); }
    public userId: number;
}

// @Route("/api/user/preferences", "PUT")
export class UpdateUserPreferences implements IReturn<UpdateUserPreferencesResponse>
{
    public constructor(init?:Partial<UpdateUserPreferences>) { (<any>Object).assign(this, init); }
    public userPreferences: { [index:string]: string; };
    public createResponse() { return new UpdateUserPreferencesResponse(); }
    public getTypeName() { return 'UpdateUserPreferences'; }
}

// @Route("/api/user/{UserId}/role/", "POST")
export class AssignUserRole implements IReturn<AssignUserRoleResponse>
{
    public constructor(init?:Partial<AssignUserRole>) { (<any>Object).assign(this, init); }
    public userId: number;
    public roleId: number;
    public plotId: number;
    public createResponse() { return new AssignUserRoleResponse(); }
    public getTypeName() { return 'AssignUserRole'; }
}

// @Route("/api/user/role/{UserRoleId}", "DELETE")
export class UnassignUserRole implements IReturn<UnassignUserRoleResponse>
{
    public constructor(init?:Partial<UnassignUserRole>) { (<any>Object).assign(this, init); }
    public userRoleId: number;
    public createResponse() { return new UnassignUserRoleResponse(); }
    public getTypeName() { return 'UnassignUserRole'; }
}

// @Route("/api/search")
export class Search implements IReturn<SearchResponse>
{
    public constructor(init?:Partial<Search>) { (<any>Object).assign(this, init); }
    public product: string;
    public startDate: string;
    public endDate: string;
    public classifications: QuestionOption[];
    public questions: QuestionOption[];
    public groups: QuestionOption[];
    public regions: QuestionOption[];
    public createResponse() { return new SearchResponse(); }
    public getTypeName() { return 'Search'; }
}

// @Route("/api/plot", "POST")
export class CreatePlot implements IReturn<SavePlotResponse>
{
    public constructor(init?:Partial<CreatePlot>) { (<any>Object).assign(this, init); }
    public plot: Plot;
    public createResponse() { return new SavePlotResponse(); }
    public getTypeName() { return 'CreatePlot'; }
}

// @Route("/api/plot/{id}", "PUT")
export class UpdatePlot implements IReturn<SavePlotResponse>
{
    public constructor(init?:Partial<UpdatePlot>) { (<any>Object).assign(this, init); }
    public plot: Plot;
    public plotId: number;
    public createResponse() { return new SavePlotResponse(); }
    public getTypeName() { return 'UpdatePlot'; }
}

// @Route("/api/plot/{PlotId}/photos", "POST")
export class UploadPlotPhotos implements IReturn<UploadPlotPhotosResponse>
{
    public constructor(init?:Partial<UploadPlotPhotos>) { (<any>Object).assign(this, init); }
    public plotId: number;
    public createResponse() { return new UploadPlotPhotosResponse(); }
    public getTypeName() { return 'UploadPlotPhotos'; }
}

// @Route("/api/plot/event/{plotEventId}/delete")
export class DeletePlotEvent implements IReturn<DeletePlotEventResponse>
{
    public constructor(init?:Partial<DeletePlotEvent>) { (<any>Object).assign(this, init); }
    public product: string;
    public plotEventId: number;
    public createResponse() { return new DeletePlotEventResponse(); }
    public getTypeName() { return 'DeletePlotEvent'; }
}

// @Route("/api/save")
export class SaveFilter implements IReturn<SaveResponse>
{
    public constructor(init?:Partial<SaveFilter>) { (<any>Object).assign(this, init); }
    public product: string;
    public preferences: UserPreference;
    public filters: string;
    public createResponse() { return new SaveResponse(); }
    public getTypeName() { return 'SaveFilter'; }
}

// @Route("/api/referenceData")
export class GetReferenceData implements IReturn<GetReferenceDataResponse>
{
    public constructor(init?:Partial<GetReferenceData>) { (<any>Object).assign(this, init); }
    public product: string;
    public createResponse() { return new GetReferenceDataResponse(); }
    public getTypeName() { return 'GetReferenceData'; }
}

// @Route("/api/questions")
export class GetQuestionReferenceData implements IReturn<GetQuestionReferenceDataResponse>
{
    public constructor(init?:Partial<GetQuestionReferenceData>) { (<any>Object).assign(this, init); }
    public product: string;
    public parentOptions: QuestionOption[];
    public createResponse() { return new GetQuestionReferenceDataResponse(); }
    public getTypeName() { return 'GetQuestionReferenceData'; }
}

// @Route("/api/report")
export class Report implements IReturn<ReportResponse>
{
    public constructor(init?:Partial<Report>) { (<any>Object).assign(this, init); }
    public product: string;
    public startDate: string;
    public endDate: string;
    public classifications: QuestionOption[];
    public questions: QuestionOption[];
    public groups: QuestionOption[];
    public regions: QuestionOption[];
    public myMarkersOnly: boolean;
    public createResponse() { return new ReportResponse(); }
    public getTypeName() { return 'Report'; }
}

// @Route("/markers")
export class GetMarker implements IReturn<GetQuestionReferenceDataResponse>
{
    public constructor(init?:Partial<GetMarker>) { (<any>Object).assign(this, init); }
    public product: string;
    public markerImage: string;
    public markerIcon: string;
    public markerColour: string;
    public createResponse() { return new GetQuestionReferenceDataResponse(); }
    public getTypeName() { return 'GetMarker'; }
}

// @Route("/auth")
// @Route("/auth/{provider}")
// @Route("/authenticate")
// @Route("/authenticate/{provider}")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    public constructor(init?:Partial<Authenticate>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe: boolean;

    // @DataMember(Order=8)
    public continue: string;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=16)
    public useTokenCookie: boolean;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public meta: { [index:string]: string; };
    public createResponse() { return new AuthenticateResponse(); }
    public getTypeName() { return 'Authenticate'; }
}

// @Route("/assignroles")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    public constructor(init?:Partial<AssignRoles>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];
    public createResponse() { return new AssignRolesResponse(); }
    public getTypeName() { return 'AssignRoles'; }
}

// @Route("/unassignroles")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    public constructor(init?:Partial<UnAssignRoles>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];
    public createResponse() { return new UnAssignRolesResponse(); }
    public getTypeName() { return 'UnAssignRoles'; }
}

// @Route("/session-to-token")
// @DataContract
export class ConvertSessionToToken implements IReturn<ConvertSessionToTokenResponse>, IPost
{
    public constructor(init?:Partial<ConvertSessionToToken>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public preserveSession: boolean;
    public createResponse() { return new ConvertSessionToTokenResponse(); }
    public getTypeName() { return 'ConvertSessionToToken'; }
}

// @Route("/access-token")
// @DataContract
export class GetAccessToken implements IReturn<GetAccessTokenResponse>, IPost
{
    public constructor(init?:Partial<GetAccessToken>) { (<any>Object).assign(this, init); }
    // @DataMember(Order=1)
    public refreshToken: string;
    public createResponse() { return new GetAccessTokenResponse(); }
    public getTypeName() { return 'GetAccessToken'; }
}

